import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DownloadCloud from 'modules/common/Svg/DownloadCloud';
import {flex50Ns} from './styles.scss';

class Download extends Component {
  constructor(props) {
    super(props);
    this.state = {hover: false};
  }

  render() {
    const {name, resourceUrl, fileType} = this.props;
    return (
      <div
        className={`pa3 ${flex50Ns}`}
        onMouseEnter={() => {
          this.setState({hover: true});
        }}
        onMouseLeave={() => {
          this.setState({hover: false});
        }}
      >
        <a href={resourceUrl} download>
          <div className="flex justify-between items-center pa3 ba b--black-10">
            <div>
              <div className="f4 fw6 default-color">{name}</div>
              <div className="silver">{fileType}</div>
            </div>
            <div>
              <DownloadCloud color={this.state.hover ? '#7eaaff' : '#aaa'} />
            </div>
          </div>
        </a>
      </div>
    );
  }
}

Download.propTypes = {
  name: PropTypes.string.isRequired,
  resourceUrl: PropTypes.string.isRequired,
  fileType: PropTypes.string,
};

export default Download;
